'use strict';

const MODULE_NAME = 'daupler.entities.durham';

var app = angular.module(MODULE_NAME, [
]);

export default MODULE_NAME;
